// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uzEV","label":"styles_label__1CK5v"};